import { render, staticRenderFns } from "./BoxCodeEdit.vue?vue&type=template&id=7b06adec&scoped=true"
import script from "./BoxCodeEdit.vue?vue&type=script&lang=js"
export * from "./BoxCodeEdit.vue?vue&type=script&lang=js"
import style0 from "./BoxCodeEdit.vue?vue&type=style&index=0&id=7b06adec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b06adec",
  null
  
)

export default component.exports